import { useTranslation } from 'libs/i18n';
import { Stack } from 'libs/ui';
import { InputLabel } from 'libs/ui/Input/templates';

import { NewLabelStyled } from './NewLabel.styles';

export interface NewLabelProps {
  label: string;
}

export const NewLabel = ({ label }: NewLabelProps) => {
  const { t } = useTranslation();
  return (
    <Stack
      alignItems="center"
      direction="row"
      justifyContent="space-between"
      spacing={4}
    >
      <InputLabel label={label} />
      <NewLabelStyled text={t('order.order.newLabel')} />
    </Stack>
  );
};
